import React from 'react';
import { Redirect } from 'react-router-dom';
import { AppServices } from 'services/AppServices';
import Locale from 'localization/Localization';
import { Spinner } from 'components/common/Spinner';
import { HttpStatusCode } from 'models/HttpStatusCode';
import { ResultMessage, ResultMessageView, ResultStyle } from '../common/ResultMessageView';

interface ResetPasswordFormProps
{
	token: string;
}

interface ResetPasswordFormState
{
	newPassword: string;
	confirmPassword: string;
	requestInProgress: boolean;
	redirectPath: string | undefined;
	resultMessage: ResultMessage | undefined;
}

export class ResetPasswordForm extends React.Component<ResetPasswordFormProps, ResetPasswordFormState>
{
	private static defaultRedirectPath = '/login';

	constructor(props: ResetPasswordFormProps)
	{
		super(props);

		this.state = {
			newPassword: '',
			confirmPassword: '',
			requestInProgress: false,
			redirectPath: undefined,
			resultMessage: undefined
		};

		this.onConfirmPasswordChanged = this.onConfirmPasswordChanged.bind(this);
		this.onNewPasswordChanged = this.onNewPasswordChanged.bind(this);
		this.onSubmitClick = this.onSubmitClick.bind(this);
	}

	private onNewPasswordChanged(event: React.ChangeEvent<HTMLInputElement>)
	{
		this.setState({ newPassword: event.target.value });
	}

	private onConfirmPasswordChanged(event: React.ChangeEvent<HTMLInputElement>)
	{
		this.setState({ confirmPassword: event.target.value });
	}

	private onSubmitClick(event: React.FormEvent<HTMLFormElement>)
	{
		event.preventDefault();
		
		this.setState({ requestInProgress: true });

		if (this.state.newPassword !== this.state.confirmPassword)
		{
			this.setState({
				requestInProgress: false,
				resultMessage: new ResultMessage(Locale.get('reset_errorPasswordsDoNotMatch'), ResultStyle.Error)
			})
			return;
		}

		AppServices.loginService.setPasswordWithResetToken(this.state.newPassword, this.props.token)
			.then((status: HttpStatusCode) =>
			{
				if (status === HttpStatusCode.OK)
				{
					this.setState({
						redirectPath: ResetPasswordForm.defaultRedirectPath
					});
				}
				else if (status === HttpStatusCode.Forbidden)
				{
					// Password does not meet requirements
					this.setState({
						requestInProgress: false,
						resultMessage: new ResultMessage(Locale.get('reset_errorPasswordRequirements') , ResultStyle.Error)
					});
				}
				else
				{
					// Error occured
					this.setState({
						requestInProgress: false,
						resultMessage: new ResultMessage(Locale.get('reset_error'), ResultStyle.Error)
					});
				}
			})
			.catch(reason =>
			{
				this.setState({
					requestInProgress: false,
					resultMessage: new ResultMessage(Locale.get('reset_error'), ResultStyle.Error)
				});
			});
	}

	public render()
	{
		if (this.state.redirectPath !== undefined)
			return <Redirect to={this.state.redirectPath} />;

		return (
			<div className='login-container'>
				{this.state.requestInProgress && <Spinner />}
				{this.state.requestInProgress === false &&
					<React.Fragment>
						<h2>{Locale.get('resetPassword_header')}</h2>
						<form onSubmit={this.onSubmitClick}>

							<label className='input-label' htmlFor='newUserPassowrd'>{Locale.get('resetPassword_newPasswordLabel')}</label>
							<input required type='password' id='newUserPassword' onChange={this.onNewPasswordChanged} />

							<label className='input-label' htmlFor='confirmUserPassword'>{Locale.get('resetPassword_confirmPasswordLabel')}</label>
							<input required type='password' id='confirmUserPassword' onChange={this.onConfirmPasswordChanged} />

							<div className='submit-container'>
								<input type='submit' value={Locale.get('resetPassword_submitButton')} />
							</div>
						</form>

						<ResultMessageView message={this.state.resultMessage} />
					</React.Fragment>
				}
			</div>
		);
	}
}